const linksInfo = [{
  url: 'http://www.activenetwork.com/information/terms-of-use.htm',
  id: 'termsOfUse',
}, {
  url: 'http://www.activenetwork.com/information/copyright-policy',
  id: 'copyrightPolicy',
}, {
  url: 'http://www.activenetwork.com/information/privacy-policy.htm',
  id: 'privacyPolicy',
}, {
  url: 'http://activesupport.force.com/usersupport',
  id: 'support',
}, {
  url: 'http://www.activenetwork.com',
  id: 'active',
}];

export default linksInfo;
